import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* paymentDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_DELETE_REQUEST
    });

    yield call(Http.delete, `payment/${action.payload?.payment.id}`);

    yield put({
      type: Constants.GLOBAL_PAYMENT_DELETE_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentDelete() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_DELETE_START, paymentDelete);
}
